import React, {useState} from 'react'
import {SignIn} from "./view/SignIn";
import {useTranslation} from "react-i18next";
import {EMPTY_STRING} from "../../utils/CommonConstants";
import {SignInApi} from "./SignInApi";
import {LocalStorageApi} from "../../utils/LocalStorageApi";
import {SignInResponseJson} from "./interfaces";
import {useHistory} from "react-router";
import {LINK} from "../../utils/Links";
import {HomePageApi} from "../home/HomePageApi";
import {HomePageResponseJson} from "../home/interfaces";


const SignInContainer = () => {

    const history = useHistory();
    const {t, i18n} = useTranslation('signin');

    const [messageId, setMessageId] = useState<string>(EMPTY_STRING);
    const [phoneNumber, setPhoneNumber] = useState<string>(EMPTY_STRING);
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [alertText, setAlertText] = useState<string>(EMPTY_STRING);

    const handleChangeLanguage = (language: string) => {
        i18n.changeLanguage(language)
    };

    const handleChangePassword = (value: string) => {
        setMessageId(value);
    };

    const handleChangePhoneNumber = (value: string) => {
        setPhoneNumber(value);
    };

    const handleErrorStatus = (status: number) => {
        if (status == 401 || status == 404) {
            setAlertText(t("alert.badCredentials"));
        } else {
            setAlertText(t("alert.defaultError"));
        }
        setShowAlert(true);
    };

    const onClickSignIn = () => {
        const normalizedPhoneNumber:string = `+${phoneNumber}`;
            SignInApi.signIn({messageId, phoneNumber:normalizedPhoneNumber})
                .then((response: SignInResponseJson) => {
                    LocalStorageApi.setAccessToken(response.token);
                    HomePageApi.getHomePageData(response.token)
                        .then((response: HomePageResponseJson) => {
                            LocalStorageApi.setDispatcherUrl(response.url);
                            history.push(LINK.HOME, response);
                        }).catch(reason => {
                        handleErrorStatus(reason.response.status);
                    });
                }).catch(reason => {
                    handleErrorStatus(reason.response.status);
                }
            )
    };


    const handleCloseAlert = () => {
        setShowAlert(false);
        setAlertText(EMPTY_STRING);
    };


    return <SignIn onClickLanguage={handleChangeLanguage}
                   t={t}
                   onChangePassword={handleChangePassword}
                   onChangePhoneNumber={handleChangePhoneNumber}
                   password={messageId}
                   phoneNumber={phoneNumber}
                   onClickSignIn={onClickSignIn}
                   showAlert={showAlert}
                   alertText={alertText}
                   onCloseAlert={handleCloseAlert}/>
};


export default SignInContainer;